// extracted by mini-css-extract-plugin
module.exports = {"root":"ToastQueueProvider_root__bc0H0"};